import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button.tsx";
import { Modal } from "@/components/Interface/Modal/Modal.tsx";
import { ButtonGroupFlexBox } from "@/components/Layout/ButtonGroupFlexBox/ButtonGroupFlexBox.tsx";

interface LeaveGroupModalProps {
  /** Keeps the confirmation button from firing the mutation twice. */
  isConfirming?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirmation dialog that opens before leaving the group. */
export const LeaveGroupModal = ({
  isConfirming,
  onConfirm,
  onClose,
}: LeaveGroupModalProps) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "friendsWithBenefits.groupOverview",
  });
  const { t: tDefault } = useTranslation();

  return (
    <Modal
      title={t("leaveTribeConfirmationTitle")}
      onClose={onClose}
      hasScroll={false}
      variant="dark"
    >
      <div className="flex flex-col gap-6">
        <p className="text-body-base font-normal">
          {t("leaveTribeConfirmationText")}
        </p>
        <ButtonGroupFlexBox
          className="!mt-0"
          rightAligned
          forceButtonWidth
          primaryButton={
            <Button
              variant="primary"
              inverted
              disabled={isConfirming}
              onClick={onConfirm}
            >
              {t("confirmLeave")}
            </Button>
          }
          secondaryButton={
            <Button variant="secondary" inverted onClick={onClose}>
              {tDefault("Common.label.cancel")}
            </Button>
          }
        />
      </div>
    </Modal>
  );
};
